import Portfolio from "../../../commonComponents/portfolio";

const Portfolio3GridContainer = () => {
  return <Portfolio gridSize={3} carShow={9} />;
};

export default Portfolio3GridContainer;
